<template>
    <div class="grcform">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>

        <div class="grc_fullwidth_lane">
            <div class="grc_maincont_lane" style="padding-left: 4px;">
              <div class="grc_sectionheader" style="margin-top:10px; margin-bottom:10px;">
                  <span class="line color1">
                    <span class="title_general" style="padding-left:10px !important;">
                      {{title}}
                      </span>
                  </span>
              </div>
            </div>
        </div>

        <div class="grc_fullwidth_lane">
        <div class="grc_maincont_lane" style="padding:10px;">

            <div class="main_col_cont">
                <div class="main_col main_col_col1">
                    <div class="innerform">
                        <GrcCombo ref="SZOLGTIPUS" v-model="SzolgTipusID" grc_labeltext="Szolgáltatás:"
                        grc_labelmode="above" grc_labelwidth="200px" grc_dropdownminwidth="300"  
                        grc_keyfield="id" grc_displayfield="Megnevezes"
                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                        v-on:dropdownopened="SetPopupRef('SZOLGTIPUS')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        v-on:grc-keydown-enter="SetControlToFocus('txtMegnevezes');"
                        style="margin-bottom:20px;"
                        />

                        <GrcText ref="txtMegnevezes" grc_labeltext="Szolgáltató neve:" grc_placeholder="..."
                        grc_labelmode="" grc_labelwidth="200px" 
                        v-on:grc-keydown-enter="SetControlToFocus('txtVaros');"
                        style="margin-bottom:20px;"
                        />
                    </div>
                </div>
                <div class="main_col main_col_col2">

                        <GrcText ref="txtVaros" grc_labeltext="Város:" grc_placeholder="..."
                        grc_labelmode="" grc_labelwidth="200px" 
                        v-on:grc-keydown-enter="SetControlToFocus('KERULET');"
                        style="margin-bottom:20px;"
                        />

                        <GrcCombo ref="KERULET" v-model="KeruletID" grc_labeltext="Budapesti kerület:"
                        grc_labelmode="above" grc_labelwidth="200px" grc_dropdownminwidth="300"  
                        grc_keyfield="id" grc_displayfield="Megnevezes"
                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                        v-on:dropdownopened="SetPopupRef('KERULET')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        v-on:grc-keydown-enter="SetControlToFocus('');"
                        style="margin-bottom:20px;"
                        />
                </div>

            </div>

            <div class="main_col_cont" style="border-bottom: dotted 2px #ccc; padding-bottom:8px;">
                <div class="main_col main_col_col1">
                    <table class="chkKartya" cellspacing="0" cellpadding="0">
                    <tr>
                        <td class="tblKartyaKeres_col1" style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkKartya" /></td>
                        <td valign="top" class="tblKartyaKeres_col2" style="text-align:left; font-family:'PremiumDefault'; font-size:14px; line-height:18px; color:#222;">Csak kártyaelfogadó helyek keresése
                        </td>
                        <td class="tblKartyaKeres_col3" style="width:140px;">

                            <GrcButton grc_text="Keresés" @grc-click="btnKereses_click" grc_readonly="false" 
                            grc_color="blue" grc_shadow="false" grc_radius="2px" grc_width="120px"
                            grc_buttonpos="left"
                            grc_textalign="center"
                            grc_lefticon="<i class='fas fa-search'></i>"
                            style="display:inline-block;" />                    

                        </td>
                    
                    </tr>
                    </table>            
                </div>
                <div class="main_col main_col_col2">
                </div>
            </div>

            <div class="result_cont">

                <div class="result_info">{{infotext}}</div>

                <div class="result_item" v-for="(item, index) in SZOLGLIST">
                    <div class="result_item_cont" style="margin-bottom:4px;">
                        <div class="result_item_col">
                            <div class="result_item_nev">{{item.Megnevezes}}</div>
                        </div>
                        <div class="result_item_col kartyaelf_cont" v-show="item.Kartyaelfogadas==1">
                            <span class="kartyaelf"><i class="far fa-credit-card" style="margin-right:10px;"></i>Kártyaelfogadóhely</span>
                        </div>
                    </div>
                    <div class="result_item_cont">
                        <div class="result_item_col">
                            <div class="result_item_linecont">
                                <a class="result_item_link" v-bind:href="item.MapUrl" target="blank"><i class="fas fa-map-marker-alt" style="margin-right:10px;"></i>{{item.Cim}}</a>
                            </div>
                            <div class="result_item_linecont" v-if="item.Telefonszam!=''">
                                <i class="fas fa-phone-volume" style="margin-right:10px;"></i>{{item.Telefonszam}}
                            </div>
                        </div>
                        <div class="result_item_col">
                            <div class="result_item_linecont" v-if="item.Weblap!=''">
                                <a class="result_item_link" v-bind:href="item.Weblap" target="blank"><i class="fas fa-file-alt" style="margin-right:10px;"></i>{{item.Weblap}}</a>
                            </div>
                            <div class="result_item_linecont" v-if="item.EmailCim!=''">
                                <a class="result_item_link" v-bind:href="'mailto:'+item.EmailCim"><i class="far fa-envelope" style="margin-right:10px;"></i>{{item.EmailCim}}</a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>



            





        </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'



export default {
  name: 'frmSzolgKeres',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCombo,
      GrcText,
      GrcCheckboxMobile,
  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmSzolgKeres",
            gPopupControlName:"",

            title:"",
            SzolgTipusID:0,
            KeruletID:0,

            SZOLGLIST:[],
            infotext:"",
            
      }
  },
  model: {
  },  
  methods:{

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmSzolgKeres", pCompName);
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }

        this.$refs[pNextComp].SetFocus();
    },


    SetLang()
    {
        this.title = "Szolgáltató kereső"; // this.GetTextBookItem("title");

        this.Init();
    },

      HideErrors()
      {
        //this.$refs.ErrorBox.HideError();
      },

    async Init()
    {
        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }

        this.$refs.SZOLGTIPUS.SetDataSource(Q.SZOLGTIPUS);
        this.$refs.SZOLGTIPUS.SetValue(0);

        this.$refs.KERULET.SetDataSource(Q.KERULET);
        this.$refs.KERULET.SetValue(0);

        this.$refs.GRCDB.HideLoading();

    },

    async btnKereses_click()
    {
        this.$refs.SZOLGLIST = [];

        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
            sMegnevezes: this.$refs.txtMegnevezes.GetText(),
            sVaros: this.$refs.txtVaros.GetText(),
            iSzolgTipusID: this.$refs.SZOLGTIPUS.GetValue(),
            iKeruletID: this.$refs.KERULET.GetValue(),
            iKartyaelfogadas: this.$refs.chkKartya.GetValue()
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Select", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }

        this.SZOLGLIST = Q.DETAILDATA;

        if (Q.DETAILDATA.length < 1)
        {
            this.infotext = "Nincs a feltételeknek megfelelő találat!";
        }
        else
        {
            if (Q.DETAILDATA.length == Q.HEADERDATA[0].ResultRowCount)
            {
                this.infotext = "Találatok száma: "+Q.DETAILDATA.length;
            }
            else
            {
                this.infotext = "Megjelenítve "+Q.DETAILDATA.length+"/"+Q.HEADERDATA[0].ResultRowCount+", pontosítsd a keresést!";
            }
        }

        this.$refs.GRCDB.HideLoading();


    },


    async ShowInfoDialog(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>

.maintitle
{
    width: 100%;
    box-sizing: border-box;
    color:#fff;
    font-family: "PremiumDefault";
    font-size:22px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px;
}

.main_col_cont
{
    width:100%;
    box-sizing: border-box;
}

.main_col
{
    width:50%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
}

.main_col_col1
{
    padding:8px 8px 0px 8px;
}

.main_col_col2
{
    padding:8px 8px 0px 8px;
}

.innerform
{
    width:100%;
    box-sizing: border-box;
}


.btn_cont
{
  width:100%;
  box-sizing: border-box;
  padding:4px 0px;
  border-top:solid 0px #ccc;
  margin-top: 0px;
  text-align: center;
}

.btn
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
}

.btn_gray2
{
  background-color: #ccc;
  color:#222;
}

.btn:hover
{
  background-color: var(--premgreen);
  color:#fff;
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}

.btn_gray:hover
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}

.chkKartya
{
    width:100%;
    margin-top: 0px;
}

.tblKartyaKeres_col1
{
    padding-top:10px;
}

.tblKartyaKeres_col2
{
    padding-top:12px;
}

.tblKartyaKeres_col3
{
    padding-top:0px;
}

.result_cont
{
    width:100%;
    box-sizing: border-box;
    margin-top: 10px;
}

.result_item
{
    width:100%;
    box-sizing: border-box;
    font-family: 'PremiumDefault';
    text-align: left;  
    color: #323232;
    margin-top: 20px;

    border-bottom: dotted 1px #ccc;
    padding: 4px;    
}

.result_item:hover
{
    background-color: #f0f0f0;
    border-color:transparent;
}

.result_item_nev
{
    width:100%;
    box-sizing: border-box;
    font-size: 22px;
    line-height: 28px;
    font-weight: 500;
}


.result_item_cont
{
    width:100%;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 20px;
    font-weight: normal;
}

.result_item_col
{
    width:50%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
    padding:4px;
}

.result_item_linecont
{
    width:100%;
    box-sizing: border-box;
    padding:4px 0px;
}

.result_item_link
{
    font-size: 16px;
    line-height: 20px;
    font-weight: normal;
    color:var(--premgreen);
}

.result_item_link:hover
{
    font-size: 16px;
    line-height: 20px;
    font-weight: normal;
    color:var(--premgreen);
}

.kartyaelf
{
    background-color: var(--premgreen);
    color: #fff;
    font-weight: normal;
    padding: 8px;
    font-size: 16px;
    line-height: 16px;
    display: inline;
    border-radius: 3px;    
}

.kartyaelf_cont
{
    text-align: right;
    padding-top:12px;
}

.result_info
{
    width:100%;
    box-sizing: border-box;
    font-family: 'PremiumDefault';
    text-align: left;  
    color:var(--premblue);
    font-size: 14px;
    line-height: 16px;
    margin:8px 0px;
}

@media (max-width:900px)
{

}

@media (max-width:700px)
{
    .main_col
    {
        width:100%;

    }

    .main_col_col1
    {
        padding: 8px 8px 0px 8px;
    }

    .main_col_col2
    {
        padding: 0px 8px 8px 8px;
    }

    .chkKartya
    {
        margin-top: 0px;
    }

    .tblKartyaKeres_col1
    {
        padding-top:10px;
    }

    .tblKartyaKeres_col2
    {
        padding-top:12px;
    }

    .tblKartyaKeres_col3
    {
        padding-top:0px;
    }

    .result_item_col
    {
        width:100%;
    }

    .result_item_nev
    {
        font-size: 16px;
        line-height: 20px;
    }

    .result_item_cont
    {
        font-size: 14px;
        line-height: 18px;
    }

    .result_item_link
    {
        font-size: 14px;
        line-height: 18px;
    }

    .kartyaelf_cont
    {
        text-align: left;
    }


}


</style>